<section class="project-creator p-0 pb-5" [ngClass]="{ external: !internalCreator }">
  <div *ngIf="!!headerStepOutOfTemplate" #header class="steps-header steps-header--with-share">
    <ul class="row mb-0 text-center steps-list">
      <li [ngClass]="lastVisibleStep >= 4 ? 'col-3' : 'col-4'">
        <div
          (click)="clickStep(1)"
          [ngClass]="{
            loading: service.steps[0]?.loading,
            active: service.stepper.currentStep === 1,
            finish: service.stepper.currentStep === 5
          }"
          class="step"
        >
          <span class="step__number">
            <span>1</span>
          </span>
          <span [innerHTML]="'ProjectCreator.Stepper.first' | translate"> </span>
        </div>
      </li>
      <li [ngClass]="lastVisibleStep >= 4 ? 'col-3' : 'col-4'">
        <div
          (click)="clickStep(2)"
          [ngClass]="{
            loading: service.steps[1]?.loading,
            active: service.stepper.currentStep === 2,
            finish: service.stepper.currentStep === 5
          }"
          class="step"
        >
          <span class="step__number">
            <span>2</span>
          </span>
          <span [innerHTML]="'ProjectCreator.Stepper.second' | translate"></span>
        </div>
      </li>
      <li [ngClass]="lastVisibleStep >= 4 ? 'col-3' : 'col-4'">
        <div
          (click)="clickStep(3)"
          [ngClass]="{
            loading: service.steps[2]?.loading,
            active: service.stepper.currentStep === 3,
            finish: service.stepper.currentStep === 5
          }"
          class="step"
        >
          <span class="step__number">
            <span>3</span>
          </span>
          <span [innerHTML]="'ProjectCreator.Stepper.third' | translate"></span>
        </div>
      </li>
      <li class="col-3" *ngIf="lastVisibleStep >= 4">
        <div
          (click)="clickStep(4)"
          [ngClass]="{
            loading: service.steps[3]?.loading,
            active: service.stepper.currentStep === 4,
            finish: service.stepper.currentStep === 5
          }"
          class="step"
        >
          <span class="step__number">
            <span>4</span>
          </span>
          <span [innerHTML]="'ProjectCreator.Stepper.fourth' | translate"></span>
        </div>
      </li>
    </ul>

    @if (isConfiguratorRoute()) {
      <app-button
        class="steps-header__share-button"
        (onClick)="copyProjectCreatorLink()"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_BLUE,
          prependSrc: '/assets/img/ic-share.svg'
        }"
      />
    }
  </div>

  <div class="project-creator-container">
    <div *ngIf="showHeaderLogo" class="py-2">
      <div
        class="project-creator-container__title d-flex justify-content-between align-items-center py-4 px-sm-5"
      >
        <span>
          <a draggable="false" href="/">
            <img draggable="false" src="./assets/img/logo.svg" alt="logo" />
          </a>
        </span>

        <span class="d-flex align-items-center">
          <app-lang-switcher></app-lang-switcher>
        </span>
      </div>
    </div>

    <div class="bg-white project-creator-container_box">
      <div *ngIf="!headerStepOutOfTemplate" #header class="steps-header">
        <ul class="row mb-0 text-center steps-list">
          <li [ngClass]="lastVisibleStep >= 4 ? 'col-3' : 'col-4'">
            <div
              (click)="clickStep(1)"
              [ngClass]="{
                loading: service.steps[0]?.loading,
                active: service.stepper.currentStep === 1,
                finish: service.stepper.currentStep === 5
              }"
              class="step"
            >
              <span class="step__number">
                <span>1</span>
              </span>
              <span [innerHTML]="'ProjectCreator.Stepper.first' | translate"> </span>
            </div>
          </li>
          <li [ngClass]="lastVisibleStep >= 4 ? 'col-3' : 'col-4'">
            <div
              (click)="clickStep(2)"
              [ngClass]="{
                loading: service.steps[1]?.loading,
                active: service.stepper.currentStep === 2,
                finish: service.stepper.currentStep === 5
              }"
              class="step"
            >
              <span class="step__number">
                <span>2</span>
              </span>
              <span [innerHTML]="'ProjectCreator.Stepper.second' | translate"></span>
            </div>
          </li>
          <li [ngClass]="lastVisibleStep >= 4 ? 'col-3' : 'col-4'">
            <div
              (click)="clickStep(3)"
              [ngClass]="{
                loading: service.steps[2]?.loading,
                active: service.stepper.currentStep === 3,
                finish: service.stepper.currentStep === 5
              }"
              class="step"
            >
              <span class="step__number">
                <span> 3</span>
              </span>
              <span [innerHTML]="'ProjectCreator.Stepper.third' | translate"></span>
            </div>
          </li>
          <li class="col-3" *ngIf="lastVisibleStep >= 4">
            <div
              (click)="clickStep(4)"
              [ngClass]="{
                loading: service.steps[3]?.loading,
                active: service.stepper.currentStep === 4,
                finish: service.stepper.currentStep === 5
              }"
              class="step"
            >
              <span class="step__number">
                <span>4</span>
              </span>
              <span [innerHTML]="'ProjectCreator.Stepper.fourth' | translate"></span>
            </div>
          </li>
        </ul>
      </div>

      <div class="project-creator-content" [class.content-extended]="service.stepper.currentStep === 5">
        @if (isViewReady()) {
          <div class="steps-container">
            <app-project-creator-first-step
              *ngIf="service.stepper.currentStep === 1"
              [config]="config?.firstStep"
              [readonly]="isReadonlyMode()"
              [useCustomPermission]="useCustomPermission"
              [customPermissions]="customPermissionsStep1"
            ></app-project-creator-first-step>
            <app-project-creator-second-step
              *ngIf="service.stepper.currentStep === 2"
              [config]="config?.secondStep"
              [readonly]="isReadonlyMode()"
              [useCustomPermission]="useCustomPermission"
              [customPermissions]="customPermissionsStep2"
              [customDocumentPermissions]="customPermissionsStep2Documents"
            ></app-project-creator-second-step>
            <app-project-creator-third-step
              *ngIf="service.stepper.currentStep === 3"
              [config]="config?.thirdStep"
              [readonly]="isReadonlyMode()"
              [useCustomPermission]="useCustomPermission"
              [customPermissions]="customPermissionsStep3"
              [internalCreator]="internalCreator"
            ></app-project-creator-third-step>
            <app-project-creator-fourth-step
              *ngIf="service.stepper.currentStep === 4 && lastVisibleStep >= 4"
              [config]="config?.fourthStep"
              [readonly]="isReadonlyMode()"
              [useCustomPermission]="useCustomPermission"
              [customPermissions]="customPermissionsStep4"
            ></app-project-creator-fourth-step>
            <app-project-creator-fifth-step
              *ngIf="service.stepper.currentStep === 5"
            ></app-project-creator-fifth-step>
          </div>
        }
      </div>

      <div
        class="steps-footer d-flex justify-content-between bg-white"
        *ngIf="isViewReady() && service.stepper.currentStep < 5 && !hideFooter"
      >
        <div>
          <app-button
            class="pr-4 pl-2"
            *ngIf="service.stepper.currentStep > 1 && service.stepper.currentStep <= lastVisibleStep"
            (click)="goToPrevStep()"
            [config]="{
              size: ButtonSize.LARGE,
              type: ButtonTypes.PRIMARY_WHITE_BORDERED,
              text: 'ProjectCreator.prevStep' | translate,
              prependSrc: './assets/img/ic-back-black.svg'
            }"
          ></app-button>
        </div>

        <app-button
          class="pl-4"
          [ngClass]="{
            'pr-2': service.stepper.currentStep < lastVisibleStep,
            'pr-4': service.stepper.currentStep > 4
          }"
          [disabled]="currentStep?.loading"
          [loading]="currentStep?.loading"
          *ngIf="service.stepper.currentStep < lastVisibleStep"
          (click)="submitCurrentStep()"
          [config]="{
            size: ButtonSize.LARGE,
            text: nextStepText | translate,
            appendSrc: service.stepper.currentStep < lastVisibleStep ? './assets/img/ic-chevron-right.svg' : ''
          }"
        />
      </div>
    </div>
  </div>
</section>

<div
  class="steps-footer steps-footer--sticky steps-footer--sticky_custom"
  *ngIf="isViewReady() && service.stepper.currentStep < 5 && !!hideFooter"
>
  <div
    [hidden]="
      !(!!currentStep?.dataChanged && !active?.snapshot?.data?.create && hasEditPermissionForCurrentStep) ||
      isReadonlyMode() ||
      isThirdStepInvalid
    "
    class="text-center steps-footer-save_wrapper"
  >
    <div class="bg-white steps-footer-save">
      <app-button
        class="bold"
        (click)="saveAndStay()"
        [disabled]="currentStep?.loading"
        [loading]="currentStep?.loading"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.PRIMARY_GREEN,
          text: 'ProjectCreator.saveAndStay' | translate,
          prependSrc: './assets/img/ic-save.svg'
        }"
      />
    </div>
  </div>

  <div class="d-flex justify-content-between bg-white steps-footer-sticky-inside">
    <div>
      <app-button
        class="pr-4 pl-2"
        *ngIf="service.stepper.currentStep > 1 && service.stepper.currentStep <= lastVisibleStep"
        (click)="goToPrevStep()"
        [config]="{
          size: ButtonSize.LARGE,
          type: ButtonTypes.PRIMARY_WHITE_BORDERED,
          text: 'ProjectCreator.prevStep' | translate,
          prependSrc: './assets/img/ic-back-black.svg'
        }"
      />
    </div>

    <div>
      <app-button
        class="pl-4"
        [ngClass]="{
          'pr-2': service.stepper.currentStep < lastVisibleStep,
          'pr-4': service.stepper.currentStep > 4
        }"
        *ngIf="service.stepper.currentStep < lastVisibleStep"
        [disabled]="currentStep?.loading || isThirdStepInvalid"
        [loading]="currentStep?.loading"
        [matTooltip]="isThirdStepInvalid ? ('requiredWarning' | translate) : ''"
        (click)="submitCurrentStep()"
        [config]="{
          size: ButtonSize.LARGE,
          text: nextStepText | translate,
          appendSrc: service.stepper.currentStep < lastVisibleStep ? './assets/img/ic-chevron-right.svg' : ''
        }"
      />
    </div>
  </div>
</div>
